import { z } from "zod"

export const BillingSettingsResponseSchema = z.object({
  billingAddress: z.object({
    company: z.string(),
    street: z.string(),
    city: z.string(),
    postalCode: z.string(),
    country: z.string(),
  }),
  contactPerson: z.object({
    firstname: z.string(),
    lastname: z.string(),
    email: z.string(),
    phone: z.string(),
    language: z.string(),
  }),
  invoicingAddress: z.discriminatedUnion("invoicingMethod", [
    z.object({
      invoicingMethod: z.literal("email"),
      invoicingEmail: z.string(),
      vatNumber: z.string(),
      invoicingReferenceNumber: z.string().optional(),
    }),
    z.object({
      invoicingMethod: z.literal("eInvoice"),
      electronicInvoicingAddress: z.string(),
      invoicingOperatorId: z.string(),
      vatNumber: z.string(),
      invoicingReferenceNumber: z.string().optional(),
    }),
  ]),
  agreeToPolicy: z.boolean(),
  policyAgreedAt: z.string().nullable(),
  policyAgreedBy: z.string().nullable(),
})

export type BillingSettingsResponse = z.infer<typeof BillingSettingsResponseSchema>
